import React from 'react';
import { Button } from '@chakra-ui/react';

export default function SubmitButton({ pending = false, disabled = false }) {
  return <Button type="submit" colorScheme="blue" variant="solid" isDisabled={disabled} isLoading={pending} aria-label={pending ? 'Creating…' : undefined}>
    Create tool instance
  </Button>;
}
